import script from "./DuplicateCompo.vue?vue&type=script&setup=true&lang=js"
export * from "./DuplicateCompo.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=9420c74e&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9420c74e"]])

export default __exports__